module.exports = __webpack_public_path__ + "img/icon_stat_first.52a20c64.svg";